import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class OauthApplication {
  active?: boolean
  createdAt?: Date
  name = ""
  clientId = ""
  clientSecret = ""
  scopes: string[] = []
  redirectUris: string[] = []
  customerTwoFactorRequired = false
}

export class OauthGrant {
  authCode = ""
  accountNumbers: string[] = []
  clientId = ""
  scopes: string[] = []
  scope = ""
  allowAllAccounts?: boolean = true
  active = true
  createdAt?: Date
  externalId = ""
  refreshToken = ""
  oauthApplication?: OauthApplication = new OauthApplication()
}

export const OAUTH_APPLICATION_DESER: SchemaDeSer<OauthApplication> =
  new SchemaDeSerBuilder<OauthApplication>(OauthApplication.bind(null))
    .ofBoolean("active")
    .ofDateTime("createdAt")
    .ofString("name")
    .ofString("clientId")
    .ofString("clientSecret")
    .ofPrimitiveArray("scopes")
    .ofPrimitiveArray("redirectUris")
    .ofBoolean("customerTwoFactorRequired")
    .toDeSer()

export const OAUTH_GRANT_DESER: SchemaDeSer<OauthGrant> =
  new SchemaDeSerBuilder<OauthGrant>(OauthGrant.bind(null))
    .ofString("authCode", "auth-code")
    .ofString("clientId", "client-id")
    .ofPrimitiveArray("accountNumbers")
    .ofPrimitiveArray("scopes")
    .ofPrimitiveArray("scope")
    .ofBoolean("allowAllAccounts")
    .ofBoolean("active")
    .ofDateTime("createdAt")
    .ofString("externalId")
    .ofString("refreshToken")
    .ofNested("oauthApplication", OAUTH_APPLICATION_DESER, OauthApplication)
    .toDeSer()
